import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Main } from './main/Main';
import { AdminMain } from './admin/AdminMain';
import { loadContainer } from './services/inversify';
import { initOrte } from './helpers/getOrt';

loadContainer();    // Lädt die Service-Bindings in den Injection-Container --> sonst würde @provideSingleton nichts bewirken

// ReactDOM.render(
//     <Main />,
//     document.getElementById('react_main')
// );

declare global {
    interface Window { startReacWIPS(key: string, divName: string, params?: any): any; }
}
initOrte();

window.startReacWIPS = (key: string, divName: string, params?: any) => {
    $(document).on('wheel', 'input[type=number]', function (e) {
        $(this).blur();
    });

    if (typeof params === 'string') {
        params = JSON.parse(atob(params));
    }
    ReactDOM.render(
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            {key === 'etool' &&
                <Main
                    params={params}
                />
            }
            {key === 'etool_admin' &&
                <AdminMain />
            }
            {key === 'mini_login' &&
                <Main
                    params={params}
                    miniLogin={true}
                />
            }
        </div>,
        document.getElementById(divName)
    );
};
